import React, {useContext} from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../../../reducers";
import {getStoreConfigLoyalty, getStoreLayoutComponentsConfig} from "../../../../services/Store/reducer";
import {getUser} from "../../../../services/User/reducer";
import {MenuSearchContext} from "../../../../services/Menu/services/Search/MenuSearchContext";
import ResponsiveComponent from "../../../../components/Common/ResponsiveComponent";

interface OwnProps {
    menuAdverts: any[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const MenuAdvertComponent = (props: Props) => {
    const {showSearchBar} = useContext(MenuSearchContext);

    if (props.menuAdverts.length === 0) return <></>;

    const drawAdverts = () => {
        return (
            <div className="container-fluid menu-promos">
                {props.menuAdverts.map((menuAdvert, index) => {
                    return (
                        <div key={index} dangerouslySetInnerHTML={{__html: menuAdvert.content}}/>
                    )
                })}
            </div>
        )
    }

    return (
        <ResponsiveComponent small={
            <>
                {!showSearchBar && drawAdverts()}
            </>
        } large={drawAdverts()}/>
    )
}


const mapStateToProps = (state: RootState) => ({
    storeLayoutComponentsConfig: getStoreLayoutComponentsConfig(state.config),
    config_loyalty: getStoreConfigLoyalty(state.config),
    user: getUser(state.user)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuAdvertComponent));